import type { ProfileTeamScope } from "@/types/users";

const normalizeRole = (value: unknown): string | null => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed ? trimmed.toLowerCase() : null;
};

/** Profile row is the only source of truth: user_metadata is user-writable. */
export const resolveUserRole = (
  profile: ProfileTeamScope | null | undefined,
): string | null => normalizeRole(profile?.role);

export const isAdminRole = (role: string | null | undefined): boolean =>
  role === "admin";

/** Functional teams own domains; this label means "see all teams" (not a data team). */
export const GLOBAL_VISIBILITY_TEAM = "admins";

export const isGlobalVisibilityTeam = (
  team: string | null | undefined,
): boolean => normalizeRole(team) === GLOBAL_VISIBILITY_TEAM;

/** Admin role or assigned team `admins` → no team filter on dashboard/reports-style queries. */
export const hasGlobalDashboardScope = (
  profile: ProfileTeamScope | null | undefined,
): boolean =>
  isAdminRole(resolveUserRole(profile)) ||
  isGlobalVisibilityTeam(profile?.team);
